import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/** Render a bit of content at the end of the document */
class Portal extends React.Component {
  static propTypes = {
    /**
     * The  elements the portal should render to the body.
     */
    children: PropTypes.node.isRequired,
    /**
     * Id for component
     */
    id: PropTypes.string
  };

  componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }

    this.defaultNode = null;
  }

  render() {
    if (!this.defaultNode) {
      this.defaultNode = document.createElement('div');
      if (this.props.id) {
        this.defaultNode.setAttribute('id', this.props.id);
      }

      document.body.appendChild(this.defaultNode);
    }

    return ReactDOM.createPortal(this.props.children, this.defaultNode);
  }
}

Portal.defaultProps = {
  id: undefined
};

export default Portal;
